import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";

const initialState = {} as IProject;

const projectSlice = createSlice({
    name: "project",
    initialState,
    reducers: {
        setProject: (state, action: PayloadAction<IProject>) => {
            Object.assign(state, action.payload);
        },
        clearProjectParameters: (state) => {
            state.parameters = []; // Clear parameters by setting it to an empty array
        },
    },
});

export const { setProject, clearProjectParameters } = projectSlice.actions;
export default projectSlice.reducer;

export const getProject = (state: RootState) => state.project;
